module.exports = __webpack_public_path__ + "static/media/undraw_processing_qj6a.11d61c06.svg";